// src/components/ArtikelThumbnail.tsx
import React, { useState } from 'react';
import { Box, Dialog, DialogContent, Tooltip } from '@mui/material';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';

type Props = {
  url?: string | null;
  alt?: string;
  size?: number; // px
};

export default function ArtikelThumbnail({ url, alt = 'Artikelbild', size = 34 }: Props) {
  const [open, setOpen] = useState(false);

  const frameSx = {
    width: size,
    height: size,
    borderRadius: 1,
    border: '1px solid rgba(0,0,0,0.12)',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: url ? 'pointer' : 'default',
    bgcolor: 'rgba(0,0,0,0.02)',
    flex: '0 0 auto',
  };

  if (!url) {
    return (
      <Tooltip title="Kein Bild vorhanden">
        <Box sx={frameSx}>
          <ImageNotSupportedOutlinedIcon sx={{ opacity: 0.65 }} fontSize="small" />
        </Box>
      </Tooltip>
    );
  }

  return (
    <>
      <Tooltip title="Klicken zum Vergrößern">
        <Box sx={frameSx} onClick={() => setOpen(true)}>
          <Box
            component="img"
            src={url}
            alt={alt}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'contain', // ✅ wie gewünscht
              display: 'block',
            }}
          />
        </Box>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogContent sx={{ p: 1 }}>
          <Box
            component="img"
            src={url}
            alt={alt}
            sx={{ width: '100%', height: 'auto', display: 'block', maxWidth: 1100 }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
